export default {"src":"/_next/static/media/ic-gnb-white-logo.1770ec26.svg","height":24,"width":178,"blurWidth":0,"blurHeight":0};